import React, {useState, useEffect, useContext} from 'react'
import {Link} from 'react-router-dom';
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import './singlepost.css'
import axios from 'axios';
import { Notify} from "notiflix";
import { Context } from '../../context/Context';
import ProgressBar from '../../components/progressbar/ProgressBar';

function SinglePost() {
    const api_uri = "https://mentorxfa.herokuapp.com/api";   
    const location = useLocation()
    const path = location.pathname.split("/")[2];
    const [post, setPost] = useState({});
    const {user} = useContext(Context);
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [url, setUrl] = useState("");
    const [updateMode, setUpdateMode] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingPerc, setloadingPerc] = useState(0);

    const history = useHistory();
   
    useEffect(() => {
        const getPost = async () => {
            const res = await axios.get(api_uri+"/posts/" + path);
            setPost(res.data);  
            setTitle(res.data.title)
            setDesc(res.data.desc)          
            setUrl(res.data.url)           
        }
        getPost();      
    }, [path])

    const handleDelete = async () => {
        setIsLoading(true) 
        setloadingPerc(0)
        try {            
            await axios.delete(api_uri+`/posts/${post._id}`, {
                data: {username: user.username, role: user.role},
            },{
                onUploadProgress: progressEvent => {

                    let perCompleted = Math.floor((progressEvent.loaded / progressEvent.total) *100 )
                    setloadingPerc(perCompleted);
                }
            });         
            setTimeout(() => {
                setIsLoading(false)
            }, 400)         
            Notify.success('Post deleted Successfully');
            
            setTimeout(() => {
                history.push("/")
            }, 700)  
        } catch (err) {
            console.log(err);
        }
    }

    const handleUpdate = async () =>{
        setIsLoading(true) 
        try {            
            await axios.put(api_uri+`/posts/${post._id}`, {
                username: user.username,
                title, 
                desc,
                url,
                role: user.role
            },{
                onUploadProgress: progressEvent => {

                    let perCompleted = Math.floor((progressEvent.loaded / progressEvent.total) * 100)
                    setloadingPerc(perCompleted);
                }
            });
            setUpdateMode(false);
            setTimeout(() => {
                setIsLoading(false)
            }, 500)
            Notify.success('Post Updated Successfully');
        } catch (err) {
            console.log(err);
        }
    }

    const handleDownload = () => {
        window.open(url)
    }
    
    return (
        
        post && (
            <>
            {
                isLoading && <ProgressBar percentage={loadingPerc}/>
            }
            <div className="single-post">
            <Link to="/" className="link">
                <i className="fas fa-chevron-left back-btn"></i>
            </Link>
            {
                updateMode ? <input type="text"  
                                    value={title} 
                                    onChange={e => setTitle(e.target.value)}  
                                    className="single-post-title-input" /> : <h2 className="single-post-title">{title}</h2>
            }
            
            <div className="single-post-info">
                <span>
                <Link to={`/?user=${post.username}`} className="link">
                By : <b> {post.username}</b>
                </Link>
                </span>
                <span>{new Date(post.createdAt).toLocaleDateString()}</span>
            </div>
            {
                (post.username === user?.username || (user && user.role === "masterAdmin")) && (
                    <div className="single-post-edit">
                        <i className="single-post-icon far fa-edit" onClick={()=>setUpdateMode(true)} ></i>
                        <i className="single-post-icon far fa-trash-alt" onClick={handleDelete} ></i>
                    </div>
                )
            }
            
            {
                updateMode ?  <textarea 
                                type="text" 
                                className="single-post-write-desc"
                                value={desc}
                                onChange={e => setDesc(e.target.value)}
                                ></textarea> : <p className="single-post-desc">{desc}</p>
            }
            <ul className="single-post-tags">
                <li className="single-post-tag-item">{post.categories}</li>                               
            </ul>
            {
                updateMode ? <> <input 
                                    type="text" 
                                    className="single-post-title-input" 
                                    value={url}
                                    onChange={e => setUrl(e.target.value)}
                                    />
                <button className="single-post-update-btn btn-green"  onClick={handleUpdate} >Update</button>
                <button className="single-post-cancel-btn btn-red" onClick={()=> setUpdateMode(false)}>Cancel</button>
                </>
                : 
                <div className="single-post-link">
                <span onClick={handleDownload}>Download Here</span> <i className="fas fa-cloud-download-alt"></i>
                </div>


            }

           
           
        </div>
       
        </>
        )
    )
}

export default SinglePost
